import {
  instance as cloudRender
} from 'wiz-cloud-render-vulkan'

import DiyCodeService from '../../../service/DiyCodeService.js'

class MarkersList {
  constructor() {
    this.eventFn = null
    this.page = {
      pageNo: 1,
      total: 0
    }
    this.markerList = []
    this.markerPtrList = []
    this.markerPtrMap = {}
    this.isDestroyed = false
    this.player = null
  }

  async getMarkerList() {
    const param = {
      FormEngineKey: 'diy_3DCoordinationManagement'
    }
    const [err, res] = await DiyCodeService.getPipesData(param)
    if (!err && res.Code === 1) {
      this.markerList.push(...res.Data)
      this.page.total = res.DataCount
      return res.Data
    }
    return []
  }
  async createPictureMarker(val, visible = true) {
    const pos = [val.XAxial, val.YAxial, val.ZAxial]
    const options = {
      id: val.Id,
      pos,
      backgroundUrl: `data://../apps/${Wiz.globalSettings.globalConfig?.modelSetting.folderName}/markers/default.png`,
      visible,
      nodeOffset: [0, 0],
      imgSize: [40, 40],
      markPosType: 4,
    }
    const {
      data
    } = await cloudRender.Marker.createByPicture(options)
    if (data) {
      this.markerPtrList.push(data[0])
      await this.createTextMarker(pos, val.Name, data[0])
    }
  }

  async createTextMarker(pos, text, ptr) {
    const options = {
      pos,
      background: '#49789e99',
      visible: false,
      nodeOffset: [60, -10],
      text,
      textColor: '#ffffffff',
      markPosType: 4,
    }
    const {
      data
    } = await cloudRender.Marker.createBySingleLine(options)
    this.markerPtrMap[ptr] = data[0]
  }
  setVisible(flag = true) {
    if (this.isDestroyed) return
    const param = this.markerPtrList.map((o) => {
      return {
        id: o,
        visible: flag,

      }
    })
    cloudRender.Marker.updateByPicture(param)
    const param2 = Object.values(this.markerPtrMap).map((o) => {
      return {
        id: o,
        visible: false,

      }
    })

    cloudRender.Marker.updateBySingleLine(param2)
  }
  addMarker(val) {
    if (this.isDestroyed) return
    this.markerList.push(val)
    this.createPictureMarker(val)
  }
  markerClick(e) {
    if (e.type === 1) {
      const item = this.markerList.find((i) => {
        return i.Id === e.markerId
      })
      if (item) {
        const pos = [item.XAxial, item.YAxial, item.ZAxial]
        this.player.Native.Camera.moveToPos(pos, 0, 50, 2)
      }
    }
    if (e.type === 2 && this.markerPtrMap[e.markerId]) {
      if (e.leave) {
        cloudRender.Marker.updateBySingleLine({
          id: this.markerPtrMap[e.markerId],
          visible: false,
        })
      } else {
        cloudRender.Marker.updateBySingleLine({
          id: this.markerPtrMap[e.markerId],
          visible: true,
        })
      }
    }
  }
  initClickEvent(isDestroyed = true) {
    if (!this.eventFn) {
      this.eventFn = (...args) => {
        this.markerClick(...args)
      }
    }
    if (!isDestroyed) {
      cloudRender.Dispatch.off('Marker', this.eventFn)
      return
    }
    cloudRender.Dispatch.on('Marker', this.eventFn)
  }
  async delete(id) {
    const index = this.markerPtrList.findIndex((o) => {
      return o === id
    })
    if (index >= 0) {
      await cloudRender.Marker.destroyMarker([id, this.markerPtrMap[id]])
      this.markerPtrList.splice(index, 1)
      delete this.markerPtrMap[id]
    }
  }

  async update(val) {
    if (this.isDestroyed) return
    const item = this.markerList.find((o) => {
      return o.Id === val.Id
    })
    if (item) {
      const param = {
        id: val.Id,
        pos: val.pos,
      }
      item.XAxial = val.XAxial
      item.YAxial = val.YAxial
      item.ZAxial = val.ZAxial
      item.Name = val.Name
      cloudRender.Marker.updateByPicture(param)
      const param2 = {
        id: this.markerPtrMap[val.Id],
        text: val.Name,
        pos: val.pos
      }
      await cloudRender.Marker.updateBySingleLine(param2)
    }
  }


  async create(player) {
    this.player = player
    this.isDestroyed = false
    this.initClickEvent()
    const list = await this.getMarkerList()
    for (let index = 0; index < list.length; index++) {
      if (this.isDestroyed) return
      const element = list[index]
      if (this.isDestroyed) return
      // eslint-disable-next-line no-await-in-loop
      await this.createPictureMarker(element)
    }
  }
  async destroy() {
    this.isDestroyed = true
    setTimeout(async () => {
      await cloudRender.Marker.destroyMarker([...this.markerPtrList, ...Object.values(this.markerPtrMap)])
      this.initClickEvent(false)

      this.eventFn = null
      this.page = {
        pageNo: 1,
        total: 0
      }
      this.markerList = []
      this.markerPtrList = []
      this.markerPtrMap = {}
    }, 500)
  }
}
export default MarkersList
